import React from 'react';

export const CreateSongProgressBarContext = React.createContext();